<template>
    <div class="d-flex justify-content-between mb-2">
        <span class="d-block">{{ $t('labels.loading_process') }}</span>
        <span class="d-block">{{ percent }} %</span>
    </div>
    <div class="progress">
        <div
            class="progress-bar progress-bar-striped progress-bar-animated"
            :style="{width: percent + '%'}"
        >
            <span class="sr-only">{{ percent }}% Complete</span>
        </div>
    </div>
</template>
<script>
export default {
    name: "TaskProgressBar",
    props: {
        done: {
            type: Number,
            default: 0
        },
        total: {
            type: Number,
            default: 0
        },
        expectedSteps: {
            type: Number,
            default: 1000
        }
    },
    computed: {
        percent() {
            const total = this.total > 0 ? this.total : this.expectedSteps + this.done;

            return Math.min(100, Math.floor((this.done / total) * 100));
        }
    }
}
</script>
